import styled from 'styled-components';

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--primary-500); // Clean border
  padding: 10px;
  /* max-width: 100%; */
  margin: auto;
  margin-bottom: 20px;

  img {
    width: 100%; 
    height: auto; // Adjust for mobile and web
    max-width: 400px; // Adjust based on your design requirements
  }

  button {
    margin-top: 10px;
    align-self: center; // Center the button
  }

  .custom-file-input {
    opacity: 0;
    width: 0.1px;
    height: 0.1px;
    position: absolute;
  }

  .btn {
    display: inline-block;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    text-align: center;
    cursor: pointer;
  }
`;

const ImageComponent = ({ avatar }) => (
  <ImageContainer>
    <img src={avatar} alt='avatar' />
    <label htmlFor='avatar' className='btn'>
      Upload Image
    </label>

    <input
      type='file'
      className='custom-file-input'
      id='avatar'
      name='avatar'
    />
  </ImageContainer>
);

export default ImageComponent;
